import { render, staticRenderFns } from "./ApplicantPendingContracts.vue?vue&type=template&id=8aa530cc&"
import script from "./ApplicantPendingContracts.vue?vue&type=script&lang=js&"
export * from "./ApplicantPendingContracts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports